export default __webpack_public_path__ + "static/media/MB.12b09035.svg";